import { useState, useCallback } from 'react';

export const useGeolocation = () => {
  const [location, setLocation] = useState<{ lat: number; lng: number } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [hasCheckedPermission, setHasCheckedPermission] = useState(false);

  const getLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser');
      setHasCheckedPermission(true);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setHasCheckedPermission(true);
      },
      (error) => {
        setError(error.message);
        setHasCheckedPermission(true);
      },
    );
  }, []);

  return { location, error, getLocation, hasCheckedPermission };
};
